// extracted by extract-css-chunks-webpack-plugin
module.exports = {"error-page":"error-page_9qZCS relative mt-3.75"};